import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-fully-paid-members',
  templateUrl: './fully-paid-members.component.html',
  styleUrls: ['./fully-paid-members.component.css']
})
export class FullyPaidMembersComponent implements OnInit {

  @Input() NoOfFullyPaidMembers: string;
  @Output() filterMembersEvent = new EventEmitter();

  program_status = '';

  constructor() { }

  ngOnInit() {
  }

  filterMemberListing(value) {
    this.program_status = value;
    this.filterMembersEvent.emit(this.program_status);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/member-billing-info/fully-paid-members/fully-paid-members.component.ts